import React from 'react';
import cx from 'classnames';
import SVGIcon from '@arrive/svg-icon';
import Button from '@arrive/button';
import { Link } from 'react-router-dom';

import styles from './NoResults.scss';

interface Props {
    onActionClick?: () => void;
    title?: string;
    icon: { id: string; viewBox: string };
    subTitle?: string;
    content?: string | React.ReactNode;
    actionText?: string;
    actionLinkTo?: string;
    className?: string;
    iconClass?: string;
    subTitleClass?: string;
    actionContent?: React.ReactChild;
}

export default function NoResults(props: Props) {
  const {
    title,
    subTitleClass,
    icon,
    subTitle,
    content,
    actionText,
    onActionClick,
    actionLinkTo,
    className,
    iconClass,
    actionContent
  } = props;
  const excludeLinkAndButton = !actionText;

  return (
    <div className={cx(styles.noResults, className)}>
      {!!title && <h1>{title}</h1>}
      <SVGIcon className={cx(styles.noResultsIcon, iconClass)} svgRef={icon} />
      {!!subTitle && <h2 className={cx(styles.noMatch, subTitleClass)}>{subTitle}</h2>}
      {!!content && <p>
        {content}
      </p>}
      {!excludeLinkAndButton && (actionLinkTo ? <Link to={actionLinkTo} className={styles.clearButton}>{actionText}</Link> : <Button className={styles.clearButton} text onClick={onActionClick}>{actionText}</Button>)}
      {actionContent}
    </div>
  )
}

NoResults.displayName = 'NoResults';
